"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const OffSkypeInviteServiceModel_1 = require("../models/OffSkypeInviteServiceModel");
const BaseRestClient_1 = require("./BaseRestClient");
function transform(model) {
    return {
        action: model.Action,
        flowId: model.FlowId,
        id: model.Id,
        resource: model.Resource,
    };
}
class HuddleApiClient extends BaseRestClient_1.BaseRestClient {
    joinAsGuest(payload) {
        return this.performApiPost('/v1/users/guests', payload, {
            eventProperties: {
                customPropertiesProvider: () => {
                    return {
                        includesCaptcha: !!payload.captcha,
                    };
                },
            },
        });
    }
    getConversation(payload) {
        return this.performApiPost('/v2/conversation/', payload).then(transform);
    }
    getOffSkypeInvite(payload) {
        return this.performApiPost('/v2/offskypeinvites', payload).then(OffSkypeInviteServiceModel_1.transform);
    }
}
exports.default = new HuddleApiClient(config_1.default.urls.api.huddle);
